<template>
	<div class="promo-step__gauges">
		<div class="promo-step__gauge">
			<div class="text-body-small text-medium-emphasis mb-1">{{ t('PromoNegotiatedVolume') }}</div>
			<v-progress-linear :model-value="Math.min(gauges.volume.percent, 100)" color="success" :height="compact ? 18 : 22" rounded>
				<span class="text-body-small font-weight-bold text-white">{{ format.uc(gauges.volume.total) }}{{ gauges.volume.objective ? ` / ${format.uc(gauges.volume.objective)}` : '' }}</span>
			</v-progress-linear>
		</div>
		<div class="promo-step__gauge">
			<div class="text-body-small text-medium-emphasis mb-1">{{ t('PromoNegotiatedValue') }}</div>
			<v-progress-linear :model-value="Math.min(gauges.value.percent, 100)" color="success" :height="compact ? 18 : 22" rounded>
				<span class="text-body-small font-weight-bold text-white">{{ format.money(gauges.value.total) }}{{ gauges.value.objective ? ` / ${format.money(gauges.value.objective)}` : '' }}</span>
			</v-progress-linear>
		</div>
	</div>
</template>

<script setup>
import { toRef } from 'vue';
import { usePromoStep } from '@/composables/usePromoStep';
import { usePromoCampaign } from '@/composables/usePromoCampaign';

const props = defineProps({
	campaign: { type: Object, required: true },
	compact: { type: Boolean, default: false },
});

const { format, t } = usePromoStep();
const { gauges } = usePromoCampaign(toRef(props, 'campaign'));
</script>
